import { render, staticRenderFns } from "./ViewSchoolData.vue?vue&type=template&id=ac84158e&scoped=true&"
import script from "./ViewSchoolData.vue?vue&type=script&lang=js&"
export * from "./ViewSchoolData.vue?vue&type=script&lang=js&"
import style0 from "./ViewSchoolData.vue?vue&type=style&index=0&id=ac84158e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac84158e",
  null
  
)

export default component.exports